module.exports = __webpack_public_path__ + "static/parade-2020-house44-3544b05f32268b1cdb6847005b1ad466.jpg";